import { useCallback } from 'react'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import { CANCELLATION_POLICIES } from 'constants/cancellationPolicies'
import useRebrandSuccessDarkColour from 'hooks/useRebrandSuccessDarkColour'

interface Props {
  cancellationOptionPolicy?: App.CancellationPolicyType
}

/**
 * Names the Fully refundable option on a Buy now, choose dates later package. Until dates are
 * booked the purchase follows the usual BNBL refund rules, so the card refund is tied to booking.
 */
function BnblCancellationOptionPolicy({ cancellationOptionPolicy }: Props) {
  const uspColour = useRebrandSuccessDarkColour()
  const highlight = useCallback((chunks: React.ReactNode) => (
    <BodyText variant="medium" weight="bold" as="span" colour={uspColour}>{chunks}</BodyText>
  ), [uspColour])

  if (cancellationOptionPolicy !== CANCELLATION_POLICIES.CASH_REFUND_PRIOR_TO_CHECK_IN_TEN_DAYS) {
    return null
  }

  return (
    <BodyText variant="medium">
      <FormattedMessage
        id="--GEvXUTsfiEgDr27pt2"
        defaultMessage="<highlight>Fully refundable</highlight> until 10 days before check-in, once your dates are booked"
        description="Cancellation option shown in the Buy now, choose dates later modal for a Fully refundable package, whose card refund applies once dates are booked"
        values={{ highlight }}
      />
    </BodyText>
  )
}

export default BnblCancellationOptionPolicy
